import { useEffect } from "react";
import { useGetAccountQuery } from "@/shared/services";
import { validateViewPaymentsTimestamp } from "../utils";

export const useViewPaymentsTimestamps = () => {
  const { data: account, isSuccess } = useGetAccountQuery();
  useEffect(() => {
    if (isSuccess && account) {
      validateViewPaymentsTimestamp(account);
    }
  }, [account, isSuccess]);
};
